import { render, staticRenderFns } from "./TotvsIcon.vue?vue&type=template&id=03e1e0d4&"
import script from "./TotvsIcon.vue?vue&type=script&lang=ts&"
export * from "./TotvsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports